import {Component} from "react";

export class SellToWebTableColumnCheckboxComponent extends Component {
}